import { truktApi } from '@api';
import { QUERY_CACHE_IDS_MAP } from '@types';
import { useQuery } from '@tanstack/react-query';

export const useContactOptionsQuery = (search: string) => {
  const queryKey = [QUERY_CACHE_IDS_MAP.CONTACTS, search];
  const query = useQuery({
    queryKey: queryKey,

    queryFn: async () => {
      const { data } = await truktApi.contact.getContacts({
        queryParams: {
          search,
        },
      });

      return data;
    },

    placeholderData: (previousData) => previousData,
    enabled: Boolean(search),
  });

  return query;
};
